import { ConfigApi } from './config.api';

const configApi = new ConfigApi();

export { configApi };
